import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { customerFragment } from '@ztechapps/customer.common'

export const buildQuery = (field: string) => buildGraphqlQuery('Customer', `_id ${field}`)
export const buildOrderQuery = (field: string) => buildGraphqlQuery('Order', `_id ${field}`)

const addressFragment = gql`
  fragment addressFragment on Address {
    _id
    company
    name
    phone
    street1
    street2
    street3
    city
    state
    zip
    country
    fullAddress
  }
`
const userProfileFragment = gql`
  fragment userProfileFragment on UserProfile {
    _id
    name
    picture
    email
  }
`

const orderMembersFragment = gql`
  fragment orderMembersFragment on User {
    _id
    profile {
      ...userProfileFragment
    }
    status
    company {
      _id
      name
    }
    address {
      ...addressFragment
    }
    addresses {
      ...addressFragment
    }
  }
  ${addressFragment}
  ${userProfileFragment}
`

const orderFragment = gql`
  fragment orderFragmentStore on Order {
    _id
    summary
    code
    status
    updatedAt
    createdAt
    net
    by {
      ...customerFragment
    }
    members {
      ...orderMembersFragment
    }
    items {
      _id
      product {
        _id
        code
        name
        coverImage
        status
        inventory {
          _id
          quantityOnHand
        }
      }
      quantity
      price
      net
      remarks
      tags
      uom {
        _id
        code
        name
        symbol
      }
    }
    shippingFee
    gross
    remarks
    tags
    taxAmount
    discount
    paymentStatus
    paymentBalance {
      _id
      balance
    }
    activeConversationId
    communication {
      _id
      email {
        _id
        to
        from
        timeStamp
        content
      }
    }
    shipping {
      _id
      status
      shipmentId
      amount
      shippingCost
      insuranceCost
      date
      trackingNumber
      trackingUrl
      pdfLabel
      pngLabel
      zplLabel
      pickupId
      pickupWindowStartDate
      pickupWindowEndDate
      pickupNotes
      pickupCancelledDate
      isVoidLabel
      voidMessage
      serviceCode
      rate {
        _id
        deliveryDays
        estimatedDeliveryDate
        serviceType
        carrierName
      }
      labelId
      billToCustomer
      billToAccount
      billToPostalCode
      billToCountryCode
      packages {
        _id
        tracking_number
        trackingUrl
      }
    }
    shippingAddress {
      ...addressFragment
    }
    billingAddress {
      ...addressFragment
    }
    customerPoNumber
    allItemsInStock
  }
  ${customerFragment}
  ${addressFragment}
  ${orderMembersFragment}
`
export const queries = buildGraphqlQuery('Order', orderFragment)
